import { useState, useEffect } from 'react';

const ReasonCardInput = ({ code, onQuantityChanged, defaultValue, disabled = false }) => {
  const [value, setValue] = useState(defaultValue)
  const [otherDesc, setOtherDesc] = useState(code.reasonDescription)

  const onKeyPressEvent = (e) => {
    if (e.charCode === 13) {
      e.target.blur();
    }
  }

  const onQtyChanged = (e) => {
    e.preventDefault()
    onQuantityChanged(code.reasonCode, e.target.value, otherDesc ? otherDesc : code.reasonDescription)
    setValue(e.target.value)
  }

  const onOtherDescChanged = (e) => {
    onQuantityChanged('R9', value, e.target.value)
    setOtherDesc(e.target.value)
  }

  const showErrorMessage = () => {
    if (value < 0) {
      return 'ไม่รองรับจำนวนติดลบ'
    }
    return ''
  }

  useEffect(() => {
    setValue(defaultValue)
  }, [ defaultValue ])

  return <div className={`p-5 border rounded ${value && value > 0 ? 'border-green-600':''}`}>
    {code.reasonCode === 'R9' ? <input type="text" placeholder='ใส่เหตุผลอื่นๆ' size="sm" value={otherDesc} onChange={onOtherDescChanged}
      className='input-form-text h-1/2 mb-[6]'/> : <label>{`${code.reasonCode !== 'R9' ? code.reasonDescription : ''}`}</label>}
    <div className='relative mt-2'>
      <input className='input-form-text'
        type="number"
        inputMode="numeric" 
        placeholder='ใส่จำนวน'
        onKeyPress={onKeyPressEvent}
        value={value}
        onChange={onQtyChanged}
        disabled={disabled}/>
      <div className="absolute inset-y-0 right-0 flex items-center">
        <label className="px-3">{code.unit}</label>
      </div>
    </div>
    <small className='text-red-500'>{showErrorMessage()}</small>
  </div >
}

export default ReasonCardInput